/*=============================================== Burger ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
/*==================== Component ====================*/
var Burger = function (_a) {
    var isOpen = _a.isOpen, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "".concat(isOpen ? "Close" : "Open", " burger") : _b, color = _a.color, props = __rest(_a, ["isOpen", "ariaLabel", "color"]);
    return (React.createElement(Container, __assign({ "$isOpen": isOpen, "aria-label": ariaLabel, "$color": color }, props),
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null)));
};
export default Burger;
/*==================== Styles ====================*/
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    border: none;\n    background-color: transparent;\n    width: 32px;\n    height: 24px;\n    color: ", ";\n\n    @media ", " {\n        &:hover {\n            color: ", ";\n        }\n\n        &:active {\n            color: ", ";\n        }\n    }\n\n    span {\n        display: block;\n        width: 100%;\n        height: 2px;\n        border-radius: ", ";\n        position: absolute;\n        left: 0;\n        background-color: currentColor;\n        transition: ", ";\n\n        &:first-child {\n            top: ", ";\n            transform: ", ";\n        }\n\n        &:nth-child(2) {\n            top: calc(50% - 2px / 2);\n            width: ", ";\n        }\n\n        &:last-child {\n            bottom: ", ";\n            transform: ", ";\n        }\n    }\n"], ["\n    position: relative;\n    border: none;\n    background-color: transparent;\n    width: 32px;\n    height: 24px;\n    color: ", ";\n\n    @media ", " {\n        &:hover {\n            color: ", ";\n        }\n\n        &:active {\n            color: ", ";\n        }\n    }\n\n    span {\n        display: block;\n        width: 100%;\n        height: 2px;\n        border-radius: ", ";\n        position: absolute;\n        left: 0;\n        background-color: currentColor;\n        transition: ", ";\n\n        &:first-child {\n            top: ", ";\n            transform: ", ";\n        }\n\n        &:nth-child(2) {\n            top: calc(50% - 2px / 2);\n            width: ", ";\n        }\n\n        &:last-child {\n            bottom: ", ";\n            transform: ", ";\n        }\n    }\n"])), Mixins.ColorsHoverDefault, Variables.Breakpoints.Hover, Mixins.ColorsHoverHover, Mixins.ColorsHoverActive, Variables.Radiuses.Round, Variables.Transitions.Short, function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? "45%" : 0);
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return $isOpen && "rotate(45deg)";
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return $isOpen && 0;
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? "45%" : 0);
}, function (_a) {
    var $isOpen = _a.$isOpen;
    return $isOpen && "rotate(-45deg)";
});
var templateObject_1;
